import minBy from "lodash/minBy";
import { CANDIDATE_PICK_RADIUS } from "views/components/visualizations/Constants";
export const clamp01 = (v) => Math.max(0, Math.min(1, v));
export const distToRect = (rect, { x, y }) => {
  let dx = 0;
  if (x < rect.left) dx = rect.left - x;
  else if (x > rect.right) dx = x - rect.right;
  let dy = 0;
  if (y < rect.top) dy = rect.top - y;
  else if (y > rect.bottom) dy = y - rect.bottom;
  return Math.hypot(dx, dy);
};
export const getTargetElement = (_, __, targetEl) => targetEl;
export const pickNearestElementAnchor = (e, candidates) => {
  const { clientX, clientY } = e.event;
  if (!candidates.length) return null;
  const inside = candidates.find(
    ({ rect: rect2 }) => clientX >= rect2.left && clientX <= rect2.right && clientY >= rect2.top && clientY <= rect2.bottom
  );
  const candidatesWithDistances = candidates.map((candidate) => {
    const rect2 = candidate.rect;
    const d = distToRect(rect2, { x: clientX, y: clientY });
    return { d, candidate };
  });
  const pointsInRadius = candidatesWithDistances.filter(({ d }) => d < CANDIDATE_PICK_RADIUS).sort((a, b) => a.d - b.d).map(({ candidate }) => candidate.pt);
  const closest = inside != null ? inside : minBy(candidatesWithDistances, "d").candidate;
  if (!closest) return null;
  const { el, rect, pt } = closest;
  const rel = {
    x: clamp01((clientX - rect.left) / Math.max(rect.width, 1)),
    y: clamp01((clientY - rect.top) / Math.max(rect.height, 1))
  };
  return { el, rel, pt, pointsInRadius };
};
export const makeElementAnchor = (e, gd, getEl) => {
  var _a, _b;
  const graphDiv = gd;
  const targetEl = (_b = (_a = e.event) == null ? void 0 : _a.target) != null ? _b : graphDiv;
  const candidates = e.points.map((pt) => {
    const el = getEl(graphDiv, pt, targetEl);
    return el ? { pt, el, rect: el.getBoundingClientRect() } : null;
  }).filter((candidate) => !!candidate);
  return pickNearestElementAnchor(e, candidates);
};
